import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="proposals" routeLang="en" />;

export const Route = createFileRoute("/en/tools/suppliers")({
  head: () => publicToolHead("proposals", "en"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
